import api from '../api';

// Mocks
// import { mockDashboardFilters, mockDashboardFiltersEmpty } from '../../mocks/mock-dashboard-filters';

/**
 * Get manager dashboard filters
 * @param {string} path - The path of the dashboard
 * @param {string | null} [contexte] - The context (optional)
 * @returns {Promise<ApiManagerDashboardFilters>} The manager dashboard filters
 */
export const getDashboardFilters = async (path, contexte = null) => {
  const contexteParam = contexte ? `&contexte=${contexte}` : '';
  const response = await api.get(`/dashboard-filters?path=${path}${contexteParam}`);
  return response.data;
  // return mockDashboardFilters;
};

/**
 * Post manager dashboard filters
 * @param {string} path - The path of the dashboard
 * @param {ApiManagerDashboardFiltersCreate} data - The dashboard filters data
 * @param {string | null} [contexte] - The context (optional)
 * @returns {Promise<ApiManagerDashboardFilters>} The updated dashboard filters
 */
export const postDashboardFilters = async (path, data, contexte = null) => {
  // Normalize selectedOption: convert empty string to null (API requires string >= 1 char or null)
  const normalizedData = {
    ...data,
    personalViews: data?.personalViews ? {
      ...data.personalViews,
      selectedOption: data.personalViews.selectedOption === '' ? null : data.personalViews.selectedOption,
    } : data.personalViews,
  };
  const contexteParam = contexte ? `&contexte=${contexte}` : '';
  const response = await api.post(`/dashboard-filters?path=${path}${contexteParam}`, normalizedData);
  return response.data;
  // return mockDashboardFilters;
};
